<template>
  <div class="fileButton">
    <div class="file-upload">
      <vue-upload-component
        :post-action="uploadAction"
        :multiple="multiple"
        :directory="directory"
        v-model="files"
        :drop="drop"
        :data="parameter"
        :active="autoUpload"
        :headers="headers"
        @input-filter="_inputFilter"
        @input-file="_inputFile"
        ref="upload">
        <i class="fa fa-plus"></i>
        选择文件
      </vue-upload-component>
      <!--:size="42949672960"-->
    </div>
  </div>
</template>

<script>
import vueUploadComponent from 'vue-upload-component'
export default {
  name: 'UploadFile',
  components: {
    vueUploadComponent
  },
  data () {
    return {
      files: [],
      batchFileList: [],
      batchTimer: null,
      uploadAlertTimer: null
    }
  },
  props: {
    uploadAction: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    directory: {
      type: Boolean,
      default: true
    },
    drop: {
      type: Boolean,
      default: true
    },
    // files: {
    //   type: Array,
    //   required: true,
    //   default: () => []
    // },
    parameter: {
      type: Object,
      default: () => {}
    },
    headers: {
      type: Object,
      default: () => {}
    },
    fileSize: {
      type: Number,
      default: 500 * 1024 * 1024
    },
    fileSizeValidateMessage: {
      type: String,
      default: '单个文件不能超过500MB，请您选择小于500MB的文件上传'
    },
    maximum: {
      type: Number,
      default: 100
    },
    maximumValidateMessage: {
      type: String,
      default: '文件过多，一次最多可以上传100个文件'
    },
    suffix: {
      type: String,
      default: ''
    },
    suffixValidateMessage: {
      type: String,
      default: '不支持此类工程文件导入'
    },
    capacityValidate: {
      type: Boolean,
      default: false
    },
    capacityValidateMessage: String,
    nowPage: String
  },
  methods: {
    // 后缀格式转换，字符串转正则
    _suffixCheckRules (accept) {
      if (accept && typeof accept === 'string') {
        let strRegex = `(.${accept.split(',').join('|.')})$`
        return new RegExp(strRegex, 'ig')
      }
      return null
    },
    _inputFilter (newFile, oldFile, prevent) {
      // 添加文件前
      if (newFile && !oldFile) {
        let message = ''
        const { size, name } = newFile
        // const { size, name, file } = newFile
        // const { fileSize, fileSizeValidateMessage, maximum, maximumValidateMessage, suffix, suffixValidateMessage, files = [] } = this
        const { suffix, suffixValidateMessage } = this
        // // 验证单文件大小
        // if (size > fileSize) {
        //   message = fileSizeValidateMessage
        // }
        // 过滤0kb文件
        if (size === 0) {
          return prevent()
        }
        // 验证单次文件上传数量
        // if (files.length + 1 > maximum) {
        //   message = maximumValidateMessage
        // }
        // 验证文件格式
        if (suffix) {
          // let nameData = name.indexOf('/') > -1 ? name.split('/') : file.fullPath.split('/')
          // let fileSuffix = nameData[nameData.length - 1]
          const regExp = this._suffixCheckRules(suffix)
          if (regExp && !regExp.test(name)) {
            message = suffixValidateMessage
          }
        }
        if (message) {
          this.$confirm({
            message,
            width: 420,
            noCancelBtn: true,
            bodyStyle: {},
            footerStyle: {}
          })
          return prevent()
        }
      }
      // 文件状态更新
      if (newFile && oldFile) {}
      // 删除已添加文件
      if (!newFile && oldFile) {}
    },
    _inputFile (newFile, oldFile) {
      // 新增上传文件
      if (newFile && !oldFile) {}
      // 文件状态更新
      if (newFile && oldFile) {}
      // 删除已添加文件
      if (!newFile && oldFile) {}
      this.$emit('input-file', {newFile, oldFile})
    },
    // 选择本地文件进行上传
    selectFile () {
      this.$refs.upload.$el.querySelector('input').click()
    },
    // 使用id获得某个对象 id: File | Object | String
    get (id) {
      this.$refs.upload.get(id)
    },
    // 添加一个或多个文件
    add (file) {
      this.$refs.upload.add(file)
    },
    // 更新某个对象
    update (file, active) {
      if (file && typeof active === 'boolean') {
        this.$refs.upload.update(file, {active})
      }
    },
    // 移除某个文件对象
    remove (file) {
      this.$refs.upload.remove(file)
    },
    // 激活或停止上传
    active (active) {
      if (typeof active === 'boolean') {
        this.$refs.upload.active = active
      }
    },
    // 清空文件列表
    clear () {
      this.$refs.upload.clear()
    }
  },
  watch: {
    files: {
      handler (newFiles, oldFiles) {
        this.$emit('change-files', {newFiles, oldFiles})
      },
      deep: true
    }
  }
}
</script>
